import { __assign } from "tslib";
// DS: i3.14
import React from 'react';
import IconWrap from '../../IconWrap';
var Search = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
        React.createElement("path", { d: "M10.588 4a6.588 6.588 0 015.44 10.307l3.535 3.535-1.331 1.331-3.48-3.479A6.588 6.588 0 1110.588 4zm0 1.976a4.612 4.612 0 100 9.224 4.612 4.612 0 000-9.224z" })))); };
Search.displayName = 'Search';
export default Search;
//# sourceMappingURL=Search.js.map